<template>
  <div class="paragraph position-relative">

    <div class="component-row">
      <div class="component-col flex-grow-1">
        <p class="whitespace-pre-line" :class="classes" v-if="!editingData" v-html="displayValue" />
        <component
          v-else
          :is="template"
          :value="form.value"
          @input="valueUpdated"
        />
      </div>
      <div class="component-col flex-grow-0">
        <div class="d-flex flex-nowrap">
          <Tag
            v-if="showActions && !editingData"
            @click.native="editingData = true"
            :block="blockData"
            :withCounterparty="state.withCounterparty"
          />
          <CommentsTrigger
            v-if="showActions && !editingData"
            v-on:toggle="comments = !comments"
            :showing="comments"
            :comments="commentsData"
          />
        </div>
      </div>
    </div>

    <Actions
      v-if="showActions && editingData"

      v-on:updated="updated"
      v-on:save="save"
      v-on:cancel="cancel"

      :saving="saving"
      :block="blockData"

      :asset-id="asset.id"
      :model="asset.model"

      :changed="changed"
    />

    <Comments
      v-if="comments"
      :comments="commentsData"
      :contract="block.contract_id"
      :block="block.id"
      v-on:commentsUpdated="commentsUpdated"
      v-on:toggle="comments = !comments"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import marked from 'marked';
import contractHelpers from '@/Mixins/contractHelpers';
import helpers from '@/Mixins/helpers';
import Actions from '@/Pages/Asset/Contract/Actions/Actions';
import DatePicker from './DatePicker';
import TextBox from './TextBox';

import Comments from '@/Pages/Asset/Contract/Comments/Comments';
import CommentsTrigger from '@/Pages/Asset/Contract/Comments/CommentsTrigger';
import Tag from '@/Pages/Asset/Contract/Actions/Tag';

Vue.component('DatePicker', DatePicker);
Vue.component('TextBox', TextBox);

export default {
  mixins: [contractHelpers, helpers],

  components: {
    Actions,
    Comments,
    CommentsTrigger,
    Tag,
  },

  props: {
    dynamic: {
      type: Boolean,
      default: false,
    },
    block: Object,
    blocks: Array,
    definitions: Array,
    showActions: Boolean,
    asset: Object,
    deletable: Boolean,
    editing: {
      type: Boolean,
      default: false,
    },
    saveTrigger: String,
    blockReference: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      blockData: this.block,
      commentsData: this.block.comments,

      editingData: this.editing,
      versions: false,
      comments: false,
      saving: false,
      errors: null,
      changed: false,

      form: {
        value: this.block.value,
      },

      components: ['DatePicker', 'TextBox'],

      // For some unknown reason, when we update this.form.value,
      // this.block.value is updateing too.
      // So here we are storing the orginal this.block.value as a string
      // so we can decode it if we need to reveser the changes (cancel())
      holdValue: JSON.stringify(this.block.value),
    };
  },

  watch: {
    editing(value) {
      this.editingData = value;
    },
    saveTrigger() {
      this.save();
    },
  },


  computed: {

    displayValue() {
      // if (this.blockReference && this.blockReference.hasOwnProperty('markdown') && this.blockReference.markdown === true) {
        return marked(this.difference)
      // }
      // return this.difference
    },

    withCounterparty() {
      return this.state.withCounterparty;
    },

    difference() {
      let html = this.references(this.block.template);

      // Replace String with components where neccesery
      // eslint-disable-next-line array-callback-return
      this.components.map((c) => {
        const regex = new RegExp(`(\\[${c}])`, 'gsm');
        let result;
        let i = 0;

        // eslint-disable-next-line no-cond-assign
        while ((result = regex.exec(html)) !== null) {
          const latest = this.blockData.latest_version;

          let text = this.form.value[c][i] || 'Enter Details';
          if (latest && latest.value[c][i]) text = this.compareValue(this.form.value[c][i], latest.value[c][i]);
          let colour = '';

          switch (this.blockData.state) {
            case 'incomplete':
              colour = this.form.value[c][i] ? 'text-success' : 'text-danger';

              break;
            case 'pending':
              colour = this.userHasRole('approver') ? 'text-danger' : 'text-success';

              break;
            case 'originatorApproved':
              colour = this.state.withCounterparty ? 'text-danger' : 'text-success';

              break;
            case 'counterpartyApproved':
              colour = !this.state.withCounterparty ? 'text-danger' : 'text-success';

              break;
            case 'accepted':
              colour = this.asset.state === 'executed' ? 'text-body' : 'text-success';
              text = this.form.value[c][i];

              break;
            default:
              colour = 'text-danger';

              break;
          }

          const value = `<span class="${colour}">${text}</span>`;

          html = html.replace(result[0], value);
          i += 1;
        }
      });

      return html;
    },

    template() {
      let html = this.block.template;

      // Replace String with components where neccesery
      // eslint-disable-next-line array-callback-return
      this.components.map((component) => {
        const regex = new RegExp(`(\\[${component}])`, 'gsm');
        let result;
        let index = 0;
        // eslint-disable-next-line no-cond-assign
        while ((result = regex.exec(html)) !== null) {
          /* eslint-disable-next-line vue/no-side-effects-in-computed-properties */

          // eslint-disable-next-line no-unused-vars
          const value = this.form.value[component][index];
          const helper = this.block.settings
          && this.block.settings[component]
          && this.block.settings[component][index]
          && this.block.settings[component][index].helper
            ? this.block.settings[component][index].helper
            : '';

          // @input="$emit('input', $event.target.value)"

          html = html.replace(
            result[0],
            `
            <${component}
              :value="value"
              @input="(v, c, i) => $emit('input', v, c, i)"

              component="${component}"
              :index="${index}"
              helper="${encodeURI(helper)}"
              :editing="${this.editingData}"
            />
          `,
          );
          index += 1;
        }
      });

      return {
        props: {
          value: Object,
        },
        template: `<div>${html}</div>`,
      };
    },
  },

  methods: {

    valuesMatch(block, version) {
      return block === version;
    },

    updated(block) {
      this.blockData = block;
    },

    valueUpdated(value, component, index) {
      this.form.value[component][index] = value;
      this.changed = true;
    },

    update(component, index, value) {
      Vue.set(this.form.value[component], index, value);
    },

    save() {
      this.saving = true;

      this.$nextTick(() => {
        window.axios
          .put(`/contract-block/${this.block.id}`, this.form)
          .then((response) => {
            this.saving = false;
            this.editingData = this.userHasRole('approver');
            // eslint-disable-next-line no-undef
            $('[data-toggle="popover"]').popover('dispose');
            this.blockData = response.data;
            this.fetchAssetState(this.asset.id);

            // Replace the holdValue if you decide to cancel again
            this.holdValue = JSON.stringify(response.data.value);
            this.changed = false;
          })
          .catch((error) => {
            this.saving = false;
            this.errors = error.response.data.errors;
            throw new Error(error);
          });
      });
    },

    cancel() {
      this.form.value = JSON.parse(this.holdValue);
      this.editingData = false;
      this.changed = false;
      // eslint-disable-next-line no-undef
      $('[data-toggle="popover"]').popover('dispose');
    },

    commentsUpdated(comments) {
      this.commentsData = comments;
    },
  },
};
</script>
